import React, { useState, useLayoutEffect, useEffect} from "react";
import {TopMenuBar} from "../components/TopMenuBar/TopMenuBar";
import AddonButton from "../components/AddonButton/AddonButton";
import EyeIcon from "../components/EyeIcon/EyeIcon";

import CanvasRenderer from "../components/CanvasRenderer/CanvasRenderer";

import * as Utils from "../Utils";

import "./style.css";

let tabCol = [];
let rows;
let numberOfTabs = 0;
let isu90tabCount = 0;
let flat463LtabCount = 0;
let c463LtabCount = 0;
let nfevtabCount = 0;
let pallet80x120tabCount = 0;
let pallet100x120tabCount = 0;
let weight;
let totalWeights = [];
let counter=0;

export const FinalPackingPage = (props) => {
  const [db] = useState(props.database);
  const [isImperial] =useState(props.isImperial);
  const [loading, setLoading] = useState(true);
  const [rowsCounter, setRowsCounter] = useState([]);
  const [settingUpTabs, setSettingUpTabs] = useState(true);
  const [weightVar, setWeightVar]= useState([]);
  const [initHandleChildData, setInitHandleChildData] = useState(0);
  const [childData, setChildData] = useState('');
  const [tabPointer, setTabPointer] = useState(0);

  //get palletVar
  const queryString = window.location.hash.split("?")[1];
  const urlParams = new URLSearchParams(queryString);
  const data = decodeURIComponent(urlParams.get("data"));
  const container = data.split(":");
  console.log("storage types"+container[0]);
  const [storeVar, setStoreVar] = useState(container[0]);
  const [palletVar, setPalletVar] = useState(Number(container[1]));
  const [quad, setQuad] = useState(Number(container[2]));
  const [showAddonButton, setShowAddonButton] = useState(false);
  const [showAdditionalLoadout, setShowAdditionalLoadout] = useState(false);
  const lastLoadOutNum = localStorage.getItem("lastLoadOut");

  

  async function waitForSetWeights() {
    const storeObject = await Utils.getAllContainersUpdateFromStore().then(
      (result) => {
        tabCol = result;
        isu90tabCount = 0;
        flat463LtabCount = 0;
        c463LtabCount = 0;
        nfevtabCount = 0;
        pallet80x120tabCount = 0;
        pallet100x120tabCount = 0;
        totalWeights = [];
        numberOfTabs = tabCol.length;
        //console.log("get back Total weights at reset"+ totalWeights.length);


        tabCol.forEach((element) => {
          if (element.containertype === "ISU-90") {
            isu90tabCount++;
          }
          if (element.containertype === "463L") {
            flat463LtabCount++;
          }
          if (element.containertype === "C463L") {
            c463LtabCount++;
          }
          if (element.containertype === "NFEV") {
            nfevtabCount++;
          }
          if (element.containertype === "80x120") {
            pallet80x120tabCount++;
          }
          if (element.containertype === "100x120") {
            pallet100x120tabCount++;
          }
        });
        totalWeights= Utils.getTotalWeightArray(isu90tabCount, flat463LtabCount, c463LtabCount, nfevtabCount, pallet80x120tabCount, pallet100x120tabCount).then((newWeights)=>{
          setWeightVar(newWeights)
          console.log("set weight:" + newWeights);
        })

      }
    );
  }
  async function waitForSetRows2() {
    const storeObject2 = await Utils.getAllItemsPlacedBoxesStore().then(
      (result) => {
        rows = result;
        console.log("get Items back how many rows" +rows.length)
        if(settingUpTabs){
          if (isu90tabCount>0){
            console.log("LayoutEffect finalpacking: ISU-90")
          }
          else if(flat463LtabCount>0){
            console.log("LayoutEffect finalpacking: 463L")
          }
          else if(c463LtabCount>0){
            console.log("LayoutEffect finalpacking: C463L")
          }
          else if(nfevtabCount>0){
            console.log("LayoutEffect finalpacking: NFEV")
          }
          else if(pallet80x120tabCount>0){
            console.log("LayoutEffect finalpacking: 80x120")
          }
          else if(pallet100x120tabCount>0){
            console.log("LayoutEffect finalpacking: 100x120")
          }
          setSettingUpTabs(false)
        }
        console.log("set rows");
        setLoading(false);
      }
    );
    setRowsCounter(storeObject2);
    //console.log('palletVar or storeVar changed:', palletVar, storeVar);
  }

  useLayoutEffect(() => {
    setLoading(true);
    counter++;
    console.log("LayoutEffect finalpacking:" + counter);
    waitForSetWeights();
    waitForSetRows2();
    console.log('palletVar or storeVar changed:', palletVar, storeVar);

  }, [rowsCounter, palletVar, storeVar]);

  useEffect(() => {
    //console.log('palletVar or storeVar changed:', palletVar, storeVar);
  }, [weightVar]);

  useEffect(() => {
      async function checkAdditionalLoadout() {
        if (lastLoadOutNum > 1) {
          const hasExtra = await Utils.checkForLastLoadOut(
            palletVar,
            storeVar,
            quad,
            lastLoadOutNum
          );
          console.log("lastLoadOutNum + show:"+ hasExtra)
          setShowAddonButton(hasExtra);
        } else {
          setShowAddonButton(false);
        }
      }
      checkAdditionalLoadout();
    }, [db, palletVar, storeVar, quad, lastLoadOutNum]);

  const handleShowAddon = () => {
    setShowAdditionalLoadout(true);
  };

  async function navigateToExpand() {
    window.location.href = `#/finalPackingPage`;
  }

  if (loading) {
    return <div className="App">Loading...</div>;
  }

  else{
    return (
      <div className="finalpacking">
        <TopMenuBar />
        <div className="under-banner-expand">
          <div className="frame-2-expand">
              <div className="expanded-box">
                <CanvasRenderer
                  className="image"
                  database={db}
                  showButtons={true}
                  print={false}
                  palletID={palletVar}
                  quad={quad}
                  storagetype={storeVar}
                  style={{ width: 905}}
                  layer={false}
                  showAdditionalLoadout={showAdditionalLoadout}
                  setShowAdditionalLoadout={setShowAdditionalLoadout}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    zIndex: 10,
                    display: "inline-flex",
                    gap: "12px"
                  }}
                >
                  <AddonButton
                    visible={showAddonButton}
                    onClick={handleShowAddon}
                  />
                  <EyeIcon onClick={navigateToExpand} expanded={true} />
                </div>
              </div>
            </div>
        </div>
      </div>
    );
}

};

export default FinalPackingPage;
